export function EnvSwitch({env,children}) {
  const currentEnv = process.env.NEXT_PUBLIC_HOST_MODE || "portfolio";
    if (currentEnv === env) {
        return children;
    }
    return null;
}